import React from "react";
import { Button } from "@postcheesy/ui-lib/atoms";
import logout from "../../api/logout";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../resources/contexts/UserContext";
import { ROUTES } from "../../resources/constants/routes";

export type LogoutButtonProps = {
  children: React.ReactNode;
  variant?: "primary" | "reversed" | "destructive" | "outline" | "secondary" | "ghost" | "link" | null | undefined;
}
export const LogoutButton: React.FC<LogoutButtonProps> = ({ children, variant }) => {
  const { setUser } = useUser();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
  
      await logout();
      localStorage.clear(); 
      setUser(null);
  
      navigate(ROUTES.LOGIN, { replace: true });
  
    } catch (error: unknown) {
      // console.error("Logout action failed:", error);
    }
  };
  return (
    <Button onClick={handleLogout} className="logout-button" variant={variant}>
      {children}
    </Button>
  );
};

